export default __webpack_public_path__ + "static/media/Yaun Cargador 1.c8eaf3ab.jpg";